import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function FundingBridgePointsSoFarForm({ fundingStatus, bridgePointsBalanceOpenFundingBalance }) {
  const getValue = () => {
    if (fundingStatus === 'CLOSED' || fundingStatus === 'CANCELLED') {
      return '';
    }

    return bridgePointsBalanceOpenFundingBalance || '';
  };

  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>BridgePoints™ So Far:</Form.Label>
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="openFundingBalance"
          id="openFundingBalance"
          value={getValue()}
          readOnly
        />
      </Col>
      <Col md={2} className="bo-same-line" />
    </>
  );
}

export default memo(FundingBridgePointsSoFarForm);
